import { render } from "./MitarbeiterIndex.vue?vue&type=template&id=2628f3a0"
import script from "./MitarbeiterIndex.vue?vue&type=script&lang=ts"
export * from "./MitarbeiterIndex.vue?vue&type=script&lang=ts"

import "./MitarbeiterIndex.vue?vue&type=style&index=0&id=2628f3a0&lang=scss"
script.render = render

export default script